var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.smarthome)?_c('div',{staticClass:"my-smart-home"},[_c('div',{staticClass:"popup",class:{active: _vm.popupActive}}),_c('nav',[_c('h1',[_vm._v(_vm._s(_vm.smarthome.name))])]),_c('div',{staticClass:"device-controller"},[_c('carousel',{attrs:{"devices":_vm.smarthome.devices,"interval":5000}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }